import * as React from 'react'
import styles from './style.module.css';
import IconProvider from '../../../../../design-system/lib/IconProvider';
import { Attach, BUSINESS, calendar_gray, calendar_time_gray, CLOSE, email_icon, hashtag2, INFO_CIRCLE, input, list_gray, PERSON } from '../../../../../assets';
import Typography from '../../../../../design-system/lib/Typography';
import Button from '../../../../../design-system/lib/Button';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import { NewCustomerHandleChange, NewOrder_dropoff_setCustomField, SetRecentAddress, Set_DropOff_Inputs, Set_Passenger_Na_Fa_Ph, Set_Pickup_Inputs, Set_Pickup_address } from '../../../../../Redux/actions/actionNames';
import { useTranslation } from 'react-i18next';
import { Get_User_Recent_Address, Register_New_Customer } from '../../../../../Redux/actions/actions';
import { Get_Addressbook_list_Api } from '../../../../../helper/api';
import Input from '../../../../../design-system/lib/Input';
import DeliveryDriverNewOrder from '../delivery_driver';
import Schedule from '../../../Schedule/Schedule';

import PhoneInput from '@onro/react-phone-input-2'
import '@onro/react-phone-input-2/lib/style.css'
import Address_details_Icon from '../../../../../assets/IconProvider/address_details_color.svg'
import ArrowDown from '../../../../../assets/IconProvider/Arrow---Down-2.svg'
import address_details from '../../../../../assets/IconProvider/address_details.svg'
import email_x from '../../../../../assets/IconProvider/email_x.svg'
import notes_X from '../../../../../assets/IconProvider/notes_X.svg'
import person_x from '../../../../../assets/IconProvider/person_x.svg'
import Radiobutton from '../../../../../design-system/lib/Radiobutton';
import CustomField_Input from '../../../../../CustomFields/Input';
import CustomField_Phone from '../../../../../CustomFields/phone';
import TooltipOnro from '../../../../../design-system/lib/Tooltip';
import CustomField_MultiLine from '../../../../../CustomFields/multiLine';
import CustomField_DropDown from '../../../../../CustomFields/DropDown';
import Toggle from '../../../../../design-system/lib/toggle';
import CustomField_Date from '../../../../../CustomFields/Date';
import CustomField_DateTime from '../../../../../CustomFields/DateTime';
import CustomField_file from '../../../../../CustomFields/file';

import jalali from "jalali-moment";
import { checkTimestamp, get_dateFormat, get_lang } from '../../../../../helper/UserData/userdate';
import EllipisWithTooltip from '../../../../../design-system/lib/ellipsis-with-tooltip';
import { isEmpty } from 'lodash';
import { emailValidate } from '../../../../../Entries/Main/components/EditPickup&DropOff/components/pickup';
import { getDropDownCustomFieldText } from '../../../customer/components/edit-customer';


function ItemsList(data, currentState, setCurrentState) {
  return (
    <div className={styles.itemsConatiner}>
      {data.map((item) => {
        return <div onClick={() => { setCurrentState(item) }}>
          <Radiobutton size="Small" state={(currentState == item.id || currentState == item.title) ? "checked" : "unchecked"} onClick={() => { }} />
          {item.icon && <img src={item.icon} />}
          <Typography weight={(currentState == item.id || currentState == item.title) ? 'Body_Middle_Bold' : 'Body_Middle_Regular'} textColor={'TextNormal'} text={item.title} className={(currentState == item.id || currentState == item.title) ? styles.dropItemchecked : styles.dropItemUnchecked} />

        </div>
      })}
    </div>
  )
}

function DeliveryInfoNewOrder(props) {
   const addressDetail = props.addressDetail;
  const block = props.block;
  const floor = props.floor;
  const unit = props.unit;
  const email = props.email;
  const senderFullName = props.recieverFullName;
  const senderPhoneNumber = props.recieverPhoneNumber;
  const noteForDriver = props.noteForDriver;

  const orderTypeActive = useSelector((state) => state.NewOrder.newOrder.orderTypeActive)
  const serviceactiveVehicleType = useSelector((state) => state.NewOrder.newOrder.service.activeVehicleType)
   const customField =   props.customField 

  const { t, i18n } = useTranslation();


  const dispatch = useDispatch();


  const closeDialoge = () => {
    props.handleShowInfo()
  };

  
  function hasCustomFieldError(fieldKey, definitions, customField, t) {
    const field = definitions.find(f => f.key === fieldKey);
    if (!field) return false;

    const value = customField[field.key];
    const config = field.config;

    const isEmptyx =
      value === undefined ||
      value === null ||
      value === "" ||
      (Array.isArray(value) && value.length === 0);

    if (!field.isRequired && isEmptyx) return false;

    if (field.isRequired && isEmptyx) {
      return false
    }

    // TEXT
    if (config.type === "singleLine" || config.type === "multiLine") {
      if (typeof value !== "string") {
        return t("custominvalid");
      }

      if (config.minLength && value.length < config.minLength ) {
        return t("customminLength", { min: config.minLength });
      }

      if (config.maxLength && value.length > config.maxLength) {
        return t("custommaxLength", { max: config.maxLength });
      }

      if (config.pattern && !new RegExp(config.pattern).test(value)) {
        return t("custompattern");
      }
    }

    // EMAIL
    if (config.type === "email") {
      if (!/^\S+@\S+\.\S+$/.test(value)) {
        return t("customemail");
      }
    }

    // PHONE
    if (config.type === "phone") {
      if (value.toString().length < 7) {
        return t("customphone");
      }
    }

    // NUMBER
    if (config.type === "number") {
      const num = Number(value);
      if (Number.isNaN(num)) {
        return t("customnumber");
      }

      if (config.min && config.min !== undefined && num < config.min ) {
        return t("customnumberMin", { min: config.min });
      }

      if (config.max && config.max !== undefined && num > config.max ) {
        return t("customnumberMax", { max: config.max });
      }
    }

    // DECIMAL


    if (config.type === "decimalNumber") {
      const num = Number(value);
      if (Number.isNaN(num)) {
        return t("customnumber");
      }

      if (config.min && config.min !== undefined && num < config.min ) {
        return t("customnumberMin", { min: config.min });

      }

      if (config.max && config.max !== undefined && num > config.max ) {
        return t("customnumberMax", { max: config.max });
      }

      if (config.precision !== undefined) {
        const decimals = value.toString().split(".")[1];
        if (decimals && decimals.length > config.precision) {
          return t("customdecimalPrecision", { p: config.precision });
        }
      }
    }



    // SELECT
    if (config.type === "select") {
      const allowed = config.choices.map(c => c.key);
      if (!allowed.includes(value)) {
        return t("customselect");
      }
    }

    // FILE
    if (config.type === "file") {

      if (value.url) {

      } else {
        if (!(value instanceof File)) {
          return t("customfileInvalid");
        }

        const sizeMB = value.size / (1024 * 1024);
        if (sizeMB > config.maxSizeMB) {
          return t("customfileSize", { max: config.maxSizeMB });
        }

        if (
          config.allowedTypes?.length &&
          !config.allowedTypes.includes(value.type)
        ) {
          return t("customfileType");
        }
      }

    }

    // DATE
    if (config.type === "date" || config.type === "dateTime") {
      if (isNaN(new Date(value).getTime())) {
        return t("customdate");
      }
    }

    return false;
  }

    
    function renderCustomField(
    field,
    value,
    filterdcustomFieldDefinitions
  ) {

 
    switch (field.config.type) {
      case 'phone':
        return (
          <div className={styles.OptionsRow}>
            <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", 
              display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}>  <span style={{ textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>
                <EllipisWithTooltip>{field?.label}</EllipisWithTooltip></span>  {(field?.isRequired && !value[field.key]) && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
              {!isEmpty(field?.toolTip) && <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={field?.toolTip} />} placement="top-end" >
                <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "16px", height: "12px", cursor: "pointer", marginInlineStart: "0px",marginInlineEnd:"auto" }} />
              </TooltipOnro>}
            </span>
            <CustomField_Phone  error={hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t)}  value={value[field.key] || ""} hint={field?.label} inputType="number" onChange={(e) => {

              dispatch(NewOrder_dropoff_setCustomField({key : field.key , value: e,
        firstDropOff: props.first,
        id: props.id }))

            }} style={{ borderColor: hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t) ? "red" : ""}} />

 
         
          </div>
        );

      case 'singleLine':
            return (
          <div className={styles.OptionsRow}>
            <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", 
              display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}> <span style={{ textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>
                <EllipisWithTooltip>{field?.label}</EllipisWithTooltip></span> {(field?.isRequired && !value[field.key]) && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
              {!isEmpty(field?.toolTip) && <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={field?.toolTip} />} placement="top-end" >
                <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "16px", height: "12px", cursor: "pointer", marginInlineStart: "0px",marginInlineEnd:"auto" }} />
              </TooltipOnro>}
            </span>
            <CustomField_Input  error={hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t)}  defvalue={value[field.key] } config={field.config} icon={input} hint={field?.label} inputType="text" onChange={(e) => {
              //               console.log(e.target.value ? e.target.value : "") 
              dispatch(NewOrder_dropoff_setCustomField({key : field.key , value: e,
        firstDropOff: props.first,
        id: props.id,}))


            }}  style={{ borderColor: hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t) ? "red" : ""}} />

 
         
          </div>
        );
      case 'email':

      
      return (
          <div className={styles.OptionsRow}>
            <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", 
              display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}> <span style={{ textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>
                <EllipisWithTooltip>{field?.label}</EllipisWithTooltip></span> {(field?.isRequired && !value[field.key]) && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
              {!isEmpty(field?.toolTip) && <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={field?.toolTip} />} placement="top-end" >
                <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "16px", height: "12px", cursor: "pointer", marginInlineStart: "0px",marginInlineEnd:"auto" }} />
              </TooltipOnro>}
            </span>
            <CustomField_Input  error={hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t)}  defvalue={value[field.key] } config={field.config} icon={email_icon} hint={field?.label} inputType="text" onChange={(e) => {
              //               console.log(e.target.value ? e.target.value : "") 
              dispatch(NewOrder_dropoff_setCustomField({key : field.key , value: e,
        firstDropOff: props.first,
        id: props.id,}))


            }}  style={{ borderColor: hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t) ? "red" : ""}} />

 
         
          </div>
        );

      case 'number':
      case 'decimalNumber':
        return (
          <div className={styles.OptionsRow}>
            <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", 
              display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}> <span style={{ textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>
                <EllipisWithTooltip>{field?.label}</EllipisWithTooltip></span> {(field?.isRequired && !value[field.key]) && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
              {!isEmpty(field?.toolTip) && <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={field?.toolTip} />} placement="top-end" >
                <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "16px", height: "12px", cursor: "pointer", marginInlineStart: "0px",marginInlineEnd:"auto" }} />
              </TooltipOnro>}
            </span>
            <CustomField_Input error={hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t)} defvalue={value[field.key] } config={field.config} icon={hashtag2} hint={field?.label} inputType="text" onChange={(e) => {
              //               console.log(e.target.value ? e.target.value : "") 
              dispatch(NewOrder_dropoff_setCustomField({key : field.key , value: e,
        firstDropOff: props.first,
        id: props.id,}))


            }} style={{ borderColor: hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t) ? "red" : ""}}  />

 
         
          </div>
        );

      case 'multiLine':
        return (
          <div className={styles.OptionsRow} style={{ height: "auto", alignItems: "start" }}>
            <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", 
              display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}> <span style={{ textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>
                <EllipisWithTooltip>{field?.label}</EllipisWithTooltip></span> {(field?.isRequired && !value[field.key]) && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
              {!isEmpty(field?.toolTip) && <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={field?.toolTip} />} placement="top-end" >
                <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "16px", height: "12px", cursor: "pointer", marginInlineStart: "0px",marginInlineEnd:"auto" }} />
              </TooltipOnro>}
            </span>
            <CustomField_MultiLine  error={hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t)}  value={value[field.key] || ""} config={field.config} icon={input} hint={field?.label} inputType="text" onChange={(e) => {
              dispatch(NewOrder_dropoff_setCustomField({key : field.key , value: e?.target.value,
        firstDropOff: props.first,
        id: props.id,}))

            }} style={{ borderColor: hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t) ? "red" : ""}}  />

 
         
          </div>
        );

      case 'boolean':
        return (
          <div className={styles.OptionsRow}>
            <span style={{ 
              fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden",
              display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center"
             }}> 
              <EllipisWithTooltip>{field?.label}</EllipisWithTooltip> {(field?.isRequired && !value[field.key]) && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
                 {!isEmpty(field?.toolTip) && <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={field?.toolTip} />} placement="top-end" >
                <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "16px", height: "12px", cursor: "pointer", marginInlineStart: "0px",marginInlineEnd:"auto" }} />
              </TooltipOnro>}
               </span>
            <Toggle isActive={value[field.key] || false} setIsHover={(e) => {
               dispatch(NewOrder_dropoff_setCustomField({key : field.key , value: !(value[field.key] || false) ,
        firstDropOff: props.first,
        id: props.id,}))

            }} />

 
         
          </div>
        );

      case 'select':
        return (

          <div className={styles.OptionsRow}>
            <span style={{
              fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden",
              display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center"
             }}> 
               <span style={{ textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>
                <EllipisWithTooltip>{field?.label}</EllipisWithTooltip></span> {(field?.isRequired && !value[field.key]) && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
                   {!isEmpty(field?.toolTip) && <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={field?.toolTip} />} placement="top-end" >
                <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "16px", height: "12px", cursor: "pointer", marginInlineStart: "0px",marginInlineEnd:"auto" }} />
              </TooltipOnro>}
                 </span>
            <CustomField_DropDown  error={hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t)}  icon={list_gray} 
            ItemsList={ItemsList(field?.config?.choices.map((item) => { return { title: item.label, data: item, id: item.key } }), value[field.key], (JOJO) => {
              dispatch(NewOrder_dropoff_setCustomField({key : field.key , value: JOJO.id,
        firstDropOff: props.first,
        id: props.id,}))


            })} textStyle={styles.DropDownTextStyle} size='Small' text={value[field.key] ? getDropDownCustomFieldText(field?.config?.choices , value[field.key]) :field?.label} placement={'bottomStart'} 
            data={field?.config?.choices} requiredText={t("Required")} onClick={(JOJO) => { }} isSelected={value[field.key]} clearText={t("clear")} clearOnClick={() => {
                     dispatch(NewOrder_dropoff_setCustomField({key : field.key , value:  null,
        firstDropOff: props.first,
        id: props.id,}))

              }} style={{ borderColor: hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t) ? "red" : ""}}  />
            

 
         
          </div>

 
         

        );

      case 'date':
        return (
          <div className={styles.OptionsRow}>
            <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex", 
              flexDirection: "row", justifyContent: "center", alignItems: "center" }}> <span style={{ textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>
                <EllipisWithTooltip>{field?.label}</EllipisWithTooltip></span>  {(field?.isRequired && !value[field.key]) && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
              {!isEmpty(field?.toolTip) && <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={field?.toolTip} />} placement="top-end" >
                <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "16px", height: "12px", cursor: "pointer", marginInlineStart: "0px",marginInlineEnd:"auto" }} />
              </TooltipOnro>}
            </span>
            <CustomField_Date icon={calendar_gray} 
             textStyle={styles.DropDownTextStyle} size='Small' 
             text={value[field.key] ? jalali(new Date(value[field.key])).locale(get_lang()).format(` ${get_dateFormat( )}`) : field?.label} 
             placement={'bottomStart'} requiredText={t("Required")} onChange={(JOJO) => { 
               dispatch(NewOrder_dropoff_setCustomField({key : field.key , value: JOJO,
        firstDropOff: props.first,
        id: props.id,}))


             }} 
            isSelected={value[field.key]} clearText={t("clear")} clearOnClick={() => { }}  style={{ borderColor: hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t) ? "red" : ""}} />

 
         

          </div>
        );

      case 'dateTime':
        return (
          <div className={styles.OptionsRow}>
            <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex", flexDirection: "row", 
              justifyContent: "center", alignItems: "center" }}> <span style={{ textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}><EllipisWithTooltip>{field?.label}</EllipisWithTooltip></span>  {(field?.isRequired && !value[field.key]) && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
              {!isEmpty(field?.toolTip) && <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={field?.toolTip} />} placement="top-end" >
                <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "16px", height: "12px", cursor: "pointer", marginInlineStart: "0px",marginInlineEnd:"auto" }} />
              </TooltipOnro>}
            </span>
            <CustomField_DateTime icon={calendar_time_gray} 
              textStyle={styles.DropDownTextStyle} size='Small' text={value[field.key] ? jalali(new Date(value[field.key])).locale(get_lang()).format(` ${checkTimestamp(new Date(value[field.key]))}`) :field?.label} 
              placement={'bottomStart'}  requiredText={t("Required")} 
              onChange={(JOJO) => { 
                dispatch(NewOrder_dropoff_setCustomField({key : field.key , value: JOJO ,
        firstDropOff: props.first,
        id: props.id,}))


             }}  isSelected={value[field.key]} clearText={t("clear")} clearOnClick={() => { }}  style={{ borderColor: hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t) ? "red" : ""}} />

 
         

          </div>

        );

      case 'file':
        return (
          <div className={styles.OptionsRow}>
            <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}> <span style={{ textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}><EllipisWithTooltip>{field?.label}</EllipisWithTooltip>
              </span>  {(field?.isRequired && !value[field.key]) && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
              {!isEmpty(field?.toolTip) && <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={field?.toolTip} />} placement="top-end" >
                <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart: '6px', width: "16px", height: "12px", cursor: "pointer", marginInlineStart: "0px",marginInlineEnd:"auto" }} />
              </TooltipOnro>}
            </span>
            <CustomField_file  error={hasCustomFieldError(field.key, filterdcustomFieldDefinitions, customField, t)}  config={field.config} defValue={value[field.key]?.name} icon={Attach} inputType={"file"} 
             textStyle={styles.DropDownTextStyle} size='Small' text={field?.label} placement={'bottomStart'} 
             requiredText={t("Required")} onChange={(JOJO) => {
                dispatch(NewOrder_dropoff_setCustomField({key : field.key , value: JOJO,
        firstDropOff: props.first,
        id: props.id,}))


             }} isSelected={value[field.key]} clearText={t("clear")} clearOnClick={() => { }} />

 
         

          </div>
        );


      default:
        return null;
    }
  }


  const Emailvalidate = (email) => {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  const handlePickUpInputs = React.useCallback((e, name) => {



    dispatch(
      Set_DropOff_Inputs({
        name: name,
        value: e  ? e  : "",
        firstDropOff: props.first,
        id: props.id,
      })
    );

  }, [props]);


  const phoneNumberOnChange = React.useCallback((res, id) => {

    dispatch(
      Set_DropOff_Inputs({
        name: id,
        value: res,
        firstDropOff: props.first,
        id: props.id,
      })
    );


  }, [props]);

  const detectOrderType = React.useCallback(() => {

    if (serviceactiveVehicleType && serviceactiveVehicleType.orderTypes?.indexOf("PickupDelivery") > -1) {
      return "PickupDelivery"
    } else {
      return "Ondemand"
    }

  }, [serviceactiveVehicleType])


  const GetDetailsInputtoText = React.useCallback(() => {

    let xxx = ""

    if (addressDetail && String(addressDetail).trim().length > 0 && (serviceactiveVehicleType?.setting?.isAddressDetailsActive && detectOrderType() == "PickupDelivery")) {
      String(xxx).length > 0 ? xxx += `, ${addressDetail}` : xxx += `${addressDetail}`;
    }

    if (block && String(block).trim().length > 0) {
      String(xxx).length > 0 ? xxx += `, ${block}` : xxx += `${block}`
    }

    if (floor && String(floor).trim().length > 0) {
      String(xxx).length > 0 ? xxx += `, ${floor}` : xxx += `${floor}`
    }

    if (unit && String(unit).trim().length > 0) {
      String(xxx).length > 0 ? xxx += `, ${unit}` : xxx += `${unit}`
    }

    if (email && String(email).trim().length > 0) {
      String(xxx).length > 0 ? xxx += `, ${email}` : xxx += `${email}`
    }


    if (senderFullName && String(senderFullName).trim().length > 0) {
      String(xxx).length > 0 ? xxx += `, ${senderFullName}` : xxx += `${senderFullName}`
    }


    if (senderPhoneNumber && String(senderPhoneNumber).trim().length > 0) {
      String(xxx).length > 0 ? xxx += `, ${senderPhoneNumber}` : xxx += `${senderPhoneNumber}`
    }



    if (noteForDriver && String(noteForDriver).trim().length > 0) {
      String(xxx).length > 0 ? xxx += `, ${noteForDriver}` : xxx += `${noteForDriver}`
    }

    return xxx

  }, [addressDetail, block, floor, unit, email, senderFullName, senderPhoneNumber, noteForDriver, serviceactiveVehicleType])


  if (orderTypeActive == "PickupDelivery" && !serviceactiveVehicleType?.setting?.isDropoffAddressEmailActive && !serviceactiveVehicleType?.setting?.isDropoffAddressPhoneActive && !serviceactiveVehicleType?.setting?.isDropoffAddressNameActive && !(serviceactiveVehicleType?.setting?.isDropoffAddressRoomFloorBlockActive && orderTypeActive != "PickupDelivery") && !(serviceactiveVehicleType?.setting?.isAddressDetailsActive && orderTypeActive == "PickupDelivery") || !props.collapsed) {
    return null
  }

  return (
    <div className={styles.NewCustomerRegisterContainer}>


      {(!props.collapsed && !props.pickupRequiredCheck) && <Typography text={t("CompleteRequiredFeileds")} weight='Body_Small_Regular' style={{
        width: "345px", overflow: 'hidden', marginTop: "6px",
        textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: "1"
      }} textColor='Red' />}


      {props.collapsed && <div className={styles.collapsed}>

        <div className={styles.titleOptionsRow} >
          <Typography text={t("Details")} weight='Body_Tiny_Regular' style={{ color: "rgba(128, 128, 128, 1)" }} />
          <div style={{ width: "auto", flex: "1", backgroundColor: "rgba(244, 244, 247, 1)", height: "1px" }} />
        </div>



              {(serviceactiveVehicleType?.setting?.isDropoffAddressRoomFloorBlockActive && orderTypeActive != "PickupDelivery") && <div className={styles.OptionsRow}>
          <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", 
            whiteSpace: "nowrap", overflow: "hidden", display: "flex", flexDirection: "row", justifyContent: "start", alignItems: "center" }}> {t("Address Details")}

          </span>

                    <div style={{width:"241px" , display:"flex" ,flexDirection:"row",justifyContent:"space-between",alignItems:"center",gap:"6px"}}>


          <CustomField_Input config={{
            "type": "singleLine",
            "minLength": 3,
            "maxLength": 500,
            "pattern": "^[A-Za-z0-9 ]+$"
          }} icon={input} hint={t("block")} defvalue={block} inputType="text" onChange={(e) => {
            handlePickUpInputs(e, "block")

          }} containerStyle={{width:"73px"}} style={{width:"59px",minWidth:"54px"}} />

                <CustomField_Input config={{
            "type": "singleLine",
            "minLength": 3,
            "maxLength": 500,
            "pattern": "^[A-Za-z0-9 ]+$"
          }} icon={input} hint={t("floor")} defvalue={floor} inputType="text" onChange={(e) => {
            handlePickUpInputs(e, "floor")

          }}  containerStyle={{width:"73px"}} style={{width:"59px",minWidth:"54px"}}/>
   <CustomField_Input config={{
            "type": "singleLine",
            "minLength": 3,
            "maxLength": 500,
            "pattern": "^[A-Za-z0-9 ]+$"
          }} icon={input} hint={t("Unit")} defvalue={unit} inputType="text" onChange={(e) => {
            handlePickUpInputs(e, "unit")

          }} containerStyle={{width:"73px"}} style={{width:"59px",minWidth:"54px"}} />


           </div>


        </div>}


        {/* singleLine */}
        {serviceactiveVehicleType?.setting?.isDropoffAddressNameActive && <div className={styles.OptionsRow}>
          <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex", flexDirection: "row", justifyContent: "start", alignItems: "center" }}> {t("Fullname")}  {(serviceactiveVehicleType?.setting?.isDropoffAddressNameRequired && senderFullName?.length < 1) && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}

          </span>
          <CustomField_Input config={{
            "type": "singleLine",
            "minLength": 3,
            "maxLength": 500,
            "pattern": "^[A-Za-z0-9 ]+$"
          }} icon={input} hint={t("Fullname")} defvalue={senderFullName} inputType="text" onChange={(e) => {
            handlePickUpInputs(e, "recieverFullName")

          }} />
        </div>}



        {/* phone */}
        {serviceactiveVehicleType?.setting?.isDropoffAddressPhoneActive && <div className={styles.OptionsRow}>
          <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex", flexDirection: "row", justifyContent: "start", alignItems: "center" }}> {t("Phonenumber")}  {(serviceactiveVehicleType && serviceactiveVehicleType.setting && serviceactiveVehicleType.setting.isDropoffAddressPhoneRequired  && senderPhoneNumber?.length < 1) && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}

          </span>
          <CustomField_Phone value={senderPhoneNumber} hint={t("Phonenumber")} inputType="number" onChange={(e) => {
            phoneNumberOnChange(e, "recieverPhoneNumber")

          }} />
        </div>}



        {/* email */}
        {(serviceactiveVehicleType?.setting?.isDropoffAddressEmailActive) && <div className={styles.OptionsRow}>
          <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex", flexDirection: "row", justifyContent: "start", alignItems: "center" }}> {t("email")}  {(serviceactiveVehicleType?.setting?.isDropoffAddressEmailRequired   && !emailValidate(email)) && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}

          </span>
          <CustomField_Input config={{
            "type": "email"
          }} icon={email_icon} hint={t("email")} inputType="text" defvalue={email} onChange={(e) => {
            phoneNumberOnChange(e, "email")

          }} />
        </div>}


 

        {/* singleLine */}
        {/* {(serviceactiveVehicleType?.setting?.isDropoffAddressRoomFloorBlockActive && orderTypeActive != "PickupDelivery") && <div className={styles.OptionsRow}>
          <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex", flexDirection: "row", justifyContent: "start", alignItems: "center" }}> {t("block")}

          </span>
          <CustomField_Input config={{
            "type": "singleLine",
            "minLength": 3,
            "maxLength": 500,
            "pattern": "^[A-Za-z0-9 ]+$"
          }} icon={input} hint={t("block")} defvalue={block} inputType="text" onChange={(e) => {
            handlePickUpInputs(e, "block")

          }} />
        </div>} */}
         {/* singleLine */}
        {/* {(serviceactiveVehicleType?.setting?.isDropoffAddressRoomFloorBlockActive && orderTypeActive != "PickupDelivery") && <div className={styles.OptionsRow}>
          <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex", flexDirection: "row", justifyContent: "start", alignItems: "center" }}> {t("floor")}

          </span>
          <CustomField_Input config={{
            "type": "singleLine",
            "minLength": 3,
            "maxLength": 500,
            "pattern": "^[A-Za-z0-9 ]+$"
          }} icon={input} hint={t("floor")} defvalue={floor} inputType="text" onChange={(e) => {
            handlePickUpInputs(e, "floor")

          }} />
        </div>} */}

        {/* singleLine */}
        {/* {(serviceactiveVehicleType?.setting?.isDropoffAddressRoomFloorBlockActive && orderTypeActive != "PickupDelivery") && <div className={styles.OptionsRow}>
          <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex", flexDirection: "row", justifyContent: "start", alignItems: "center" }}> {t("Unit")}

          </span>
          <CustomField_Input config={{
            "type": "singleLine",
            "minLength": 3,
            "maxLength": 500,
            "pattern": "^[A-Za-z0-9 ]+$"
          }} icon={input} hint={t("Unit")} defvalue={unit} inputType="text" onChange={(e) => {
            handlePickUpInputs(e, "unit")

          }} />
        </div>} */}


        {/* singleLine */}
        {(serviceactiveVehicleType?.setting?.isAddressDetailsActive && orderTypeActive == "PickupDelivery") && <div className={styles.OptionsRow}>
          <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex", flexDirection: "row", justifyContent: "start", alignItems: "center" }}> {t("addressDetail")}

          </span>
          <CustomField_Input config={{
            "type": "singleLine",
            "minLength": 3,
            "maxLength": 500,
            "pattern": "^[A-Za-z0-9 ]+$"
          }} icon={address_details} hint={t("addressDetail")} defvalue={addressDetail} inputType="text" onChange={(e) => {
            handlePickUpInputs(e, "addressDetail")

          }} />
        </div>}


        {/* singleLine */}
        {(orderTypeActive != "PickupDelivery") && <div className={styles.OptionsRow}>
          <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex", flexDirection: "row", justifyContent: "start", alignItems: "center" }}> {t("notesfordriver")}

          </span>
          <CustomField_Input config={{
            "type": "singleLine",
            "minLength": 3,
            "maxLength": 500,
            "pattern": "^[A-Za-z0-9 ]+$"
          }} icon={notes_X} hint={t("notesfordriver")} defvalue={noteForDriver} inputType="text" onChange={(e) => {
            handlePickUpInputs(e, "noteForDriver")

          }} />
        </div>}





       {(serviceactiveVehicleType && serviceactiveVehicleType?.orderCustomFieldDefinitions.filter((item) => { return item.stage == "dropoff" }).length > 0 ) &&  <div className={styles.titleOptionsRow} >
          <Typography text={t("Custom")} weight='Body_Tiny_Regular' style={{ color: "rgba(128, 128, 128, 1)" }} />
          <div style={{ width: "auto", flex: "1", backgroundColor: "rgba(244, 244, 247, 1)", height: "1px" }} />
        </div>}



        
     {serviceactiveVehicleType?.orderCustomFieldDefinitions?.filter((item) => { return item.stage == "dropoff" }).map(field =>
            renderCustomField(field, props.customField , serviceactiveVehicleType?.orderCustomFieldDefinitions  )
          )}


         {/* <div className={styles.OptionsRow}>
          <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}> phone  {true && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
            <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={t("refid_tooltip")} />} placement="top-end" >
              <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart:  '6px', width: "12px", height: "12px", cursor: "pointer", marginInlineStart: "auto" }} />
            </TooltipOnro>
          </span>
          <CustomField_Phone value={null} hint="phone" inputType="number" onChange={(e) => {
            console.log(e)

          }} />
        </div>

         <div className={styles.OptionsRow}>
          <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}> singleLine  {true && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
            <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={t("refid_tooltip")} />} placement="top-end" >
              <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart:  '6px', width: "12px", height: "12px", cursor: "pointer", marginInlineStart: "auto" }} />
            </TooltipOnro>
          </span>
          <CustomField_Input config={{
            "type": "singleLine",
            "minLength": 3,
            "maxLength": 50,
            "pattern": "^[A-Za-z0-9 ]+$"
          }} icon={input} hint={t("singleLine")} inputType="text" onChange={(e) => {
 
          }} />
        </div>


         <div className={styles.OptionsRow}>
          <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}> email  {true && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
            <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={t("email")} />} placement="top-end" >
              <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart:  '6px', width: "12px", height: "12px", cursor: "pointer", marginInlineStart: "auto" }} />
            </TooltipOnro>
          </span>
          <CustomField_Input config={{
            "type": "email"
          }} icon={email_icon} hint={t("singleLine")} inputType="text" onChange={(e) => {
 
          }} />
        </div>


         <div className={styles.OptionsRow} style={{ height: "auto", alignItems: "start" }}>
          <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}> multiLine  {true && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
            <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={t("refid_tooltip")} />} placement="top-end" >
              <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart:  '6px', width: "12px", height: "12px", cursor: "pointer", marginInlineStart: "auto" }} />
            </TooltipOnro>
          </span>
          <CustomField_MultiLine config={{
            "type": "multiLine",
            "minLength": 10,
            "maxLength": 300
          }} icon={input} hint={t("multiLine")} inputType="text" onChange={(e) => {
 
          }} />
        </div>



         <div className={styles.OptionsRow}>
          <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}> number  {true && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
            <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={t("refid_tooltip")} />} placement="top-end" >
              <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart:  '6px', width: "12px", height: "12px", cursor: "pointer", marginInlineStart: "auto" }} />
            </TooltipOnro>
          </span>
          <CustomField_Input config={{
            "type": "number"
          }} icon={input} hint={t("number")} inputType="number" onChange={(e) => {
 
          }} />
        </div>
 

        <div className={styles.OptionsRow}>
          <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}> <span style={{ textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>decimalNumber</span>  {true && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
            <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={t("refid_tooltip")} />} placement="top-end" >
              <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart:  '6px', width: "12px", height: "12px", cursor: "pointer", marginInlineStart: "auto" }} />
            </TooltipOnro>
          </span>
          <CustomField_Input config={{
            "type": "decimalNumber",
            "precision": 2,
            "min": 0,
            "max": 100000
          }} icon={input} hint={t("decimalNumber")} inputType="number" onChange={(e) => {
 
          }} />
        </div>



 

        <div className={styles.OptionsRow}>
          <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}> boolean {true && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>} </span>
          <Toggle isActive={false} setIsHover={() => { }} />
        </div>



 

        <div className={styles.OptionsRow}>
          <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}> select {true && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>} </span>
          <CustomField_DropDown icon={list_gray} ItemsList={ItemsList([{ key: "key1", label: "key1" }, { key: "key2", label: "key2" }, { key: "key3", label: "key3" }].map((item) => { return { title: item.label, data: item, id: item.key } }), "key3", (JOJO) => { })} textStyle={styles.DropDownTextStyle} size='Small' text={t("Select")} placement={'bottomStart'} data={[{ key: "key1", label: "key1" }, { key: "key2", label: "key2" }, { key: "key3", label: "key3" }]} requiredText={t("Required")} onClick={(JOJO) => { }} isSelected={false} clearText={t("clear")} clearOnClick={() => { }} />
        </div>



         <div className={styles.OptionsRow}>
          <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}> <span style={{ textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>date</span>  {true && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
            <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={t("refid_tooltip")} />} placement="top-end" >
              <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart:  '6px', width: "12px", height: "12px", cursor: "pointer", marginInlineStart: "auto" }} />
            </TooltipOnro>
          </span>
          <CustomField_Date icon={calendar_gray} ItemsList={ItemsList([{ key: "key1", label: "key1" }, { key: "key2", label: "key2" }, { key: "key3", label: "key3" }].map((item) => { return { title: item.label, data: item, id: item.key } }), "key3", (JOJO) => { })} textStyle={styles.DropDownTextStyle} size='Small' text={t("Select")} placement={'bottomStart'} data={[{ key: "key1", label: "key1" }, { key: "key2", label: "key2" }, { key: "key3", label: "key3" }]} requiredText={t("Required")} onClick={(JOJO) => { }} isSelected={false} clearText={t("clear")} clearOnClick={() => { }} />

        </div>



         <div className={styles.OptionsRow}>
          <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}> <span style={{ textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>dateTime</span>  {true && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
            <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={t("refid_tooltip")} />} placement="top-end" >
              <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart:  '6px', width: "12px", height: "12px", cursor: "pointer", marginInlineStart: "auto" }} />
            </TooltipOnro>
          </span>
          <CustomField_DateTime icon={calendar_time_gray} ItemsList={ItemsList([{ key: "key1", label: "key1" }, { key: "key2", label: "key2" }, { key: "key3", label: "key3" }].map((item) => { return { title: item.label, data: item, id: item.key } }), "key3", (JOJO) => { })} textStyle={styles.DropDownTextStyle} size='Small' text={t("Select")} placement={'bottomStart'} data={[{ key: "key1", label: "key1" }, { key: "key2", label: "key2" }, { key: "key3", label: "key3" }]} requiredText={t("Required")} onClick={(JOJO) => { }} isSelected={false} clearText={t("clear")} clearOnClick={() => { }} />

        </div>



         <div className={styles.OptionsRow}>
          <span style={{ fontSize: '13px', height:"23.3px", alignItems: "center" , display:"flex" , fontWeight: '400', color: "rgba(72, 72, 72, 1)", marginInlineEnd: "auto", textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}> <span style={{ textDecoration: "none", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>file</span>  {true && <span style={{ fontWeight: "700", color: "rgba(208, 20, 0, 1)" }}>*</span>}
            <TooltipOnro open={true} tooltipClassName={styles.TooltipOnro} title={<Typography style={{ padding: "7px" }} weight="Body_Small_Medium" text={t("refid_tooltip")} />} placement="top-end" >
              <img src={INFO_CIRCLE} style={{ filter: "grayscale(1)", paddingInlineStart:  '6px', width: "12px", height: "12px", cursor: "pointer", marginInlineStart: "auto" }} />
            </TooltipOnro>
          </span>
          <CustomField_file config={{
            "type": "file",
            "maxSizeMB": 10,
            "allowedTypes": [
              "application/pdf",
              "image/jpeg",
              "image/png",
              "text/plain"
            ]
          }} icon={Attach} inputType={"file"} ItemsList={ItemsList([{ key: "key1", label: "key1" }, { key: "key2", label: "key2" }, { key: "key3", label: "key3" }].map((item) => { return { title: item.label, data: item, id: item.key } }), "key3", (JOJO) => { })} textStyle={styles.DropDownTextStyle} size='Small' text={t("Select")} placement={'bottomStart'} data={[{ key: "key1", label: "key1" }, { key: "key2", label: "key2" }, { key: "key3", label: "key3" }]} requiredText={t("Required")} onClick={(JOJO) => { }} isSelected={true} clearText={t("clear")} clearOnClick={() => { }} />

        </div> */}




      </div>

      }
      {/* {props.collapsed && <div className={styles.body}>

        <div className={styles.inputsConatiner}>
          {(serviceactiveVehicleType?.setting?.isDropoffAddressRoomFloorBlockActive && orderTypeActive != "PickupDelivery") && <div className={styles.threeCOLUMNS}>
            <Input type={"text"} placeHolder={t("block")} value={block} inputStyle={{ width: "inherit" }} onChange={(e) => { handlePickUpInputs(e, "block") }} />
            <Input type={"text"} placeHolder={t("Floor")} value={floor} inputStyle={{ width: "inherit" }} onChange={(e) => { handlePickUpInputs(e, "floor") }} />
            <Input type={"text"} placeHolder={t("Unit")} value={unit} inputStyle={{ width: "inherit" }} onChange={(e) => { handlePickUpInputs(e, "unit") }} />
          </div>}

          {(serviceactiveVehicleType?.setting?.isAddressDetailsActive && orderTypeActive == "PickupDelivery") &&
            <Input iconStart={address_details} type={"text"} placeHolder={t("addressDetail")} value={addressDetail} inputStyle={{ width: "inherit" }} onChange={(e) => { handlePickUpInputs(e, "addressDetail") }} />
          }


          {(serviceactiveVehicleType?.setting?.isDropoffAddressNameActive || serviceactiveVehicleType?.setting?.isDropoffAddressEmailActive) && <div className={styles.twoColumnContainer}>
            {serviceactiveVehicleType?.setting?.isDropoffAddressNameActive && <Input iconStart={person_x} isRequired={serviceactiveVehicleType?.setting?.isDropoffAddressNameRequired} isRequiredText={"*"} type={"text"} placeHolder={t("Fullname")} value={senderFullName} onChange={(e) => { handlePickUpInputs(e, "recieverFullName") }} />}


            {serviceactiveVehicleType?.setting?.isDropoffAddressEmailActive && <Input iconStart={email_x} isRequired={serviceactiveVehicleType?.setting?.isDropoffAddressEmailRequired} error={Emailvalidate(email) ? "" : t("Emailisnotcorrect")} isRequiredText={"*"} type={"text"} value={email} placeHolder={t("email")} onChange={(e) => { handlePickUpInputs(e, "email") }} />}


          </div>}

          {serviceactiveVehicleType?.setting?.isDropoffAddressPhoneActive &&

            <div className={styles.PhoneInput}>
              <PhoneInput
                countryCodeEditable={false}
                country={String(global.config.countryCca2).toLowerCase()}
                className={clsx(styles.inputContainer, "newUi_senderphonenumberPickup")}
                value={senderPhoneNumber}
                onChange={(e1, e2, e3, e4) => { phoneNumberOnChange(e4, "recieverPhoneNumber") }}
                enableLongNumbers={true}
                inputProps={{ type: "text" }}
                copyNumbersOnly={false}
                autoFormat={false}
                placeHolder={t("Phonenumber")}

              />
        
              {serviceactiveVehicleType &&
                serviceactiveVehicleType.setting &&
                serviceactiveVehicleType.setting.isDropoffAddressPhoneRequired && String(senderPhoneNumber).length == 0 && (
                  <span className={`inputRequired ${styles.PhoneInputRequired}`}>
                    *
                  </span>
                )}
            </div>

          }

          {orderTypeActive != "PickupDelivery" && <Input iconStart={notes_X} type={"text"} value={noteForDriver} placeHolder={t("notesfordriver")} onChange={(e) => { handlePickUpInputs(e, "noteForDriver") }} />
          }


        </div>

      </div>} */}



    </div>
  )
}

export default DeliveryInfoNewOrder